export default "__VITE_ASSET__DR9cIjSH__"